module.exports = __webpack_public_path__ + "img/pic_shop_ popup1@2x.4ac81b07.png";